import { FC, ReactNode } from "react";
import { Button, Label } from "@capacit-com/lara-law-shared-ui";
import ItemReorderList, { ReorderListItem } from "./ItemReorderList";

interface UserDataOrderSectionProps {
  useGlobalOrder: boolean;
  items: ReorderListItem[];
  droppableId: string;
  onUseGlobalOrderChange: (useGlobal: boolean) => void;
  onItemOrderChange: (orderedIds: string[]) => void;
  onUpdateGlobalOrder?: () => void;
  isUpdatingGlobal?: boolean;
  renderItemLabel?: (item: ReorderListItem) => ReactNode;
}

const UserDataOrderSection: FC<UserDataOrderSectionProps> = ({
  useGlobalOrder,
  items,
  droppableId,
  onUseGlobalOrderChange,
  onItemOrderChange,
  onUpdateGlobalOrder,
  isUpdatingGlobal = false,
  renderItemLabel,
}) => {
  return (
    <div className="space-y-3">
      <Label>Rækkefølge</Label>
      <div className="space-y-2">
        <label className="flex items-center gap-2 text-sm cursor-pointer">
          <input
            type="radio"
            name={`${droppableId}-order-mode`}
            checked={useGlobalOrder}
            onChange={() => onUseGlobalOrderChange(true)}
            className="accent-primary"
          />
          Følg global rækkefølge
        </label>
        <label className="flex items-center gap-2 text-sm cursor-pointer">
          <input
            type="radio"
            name={`${droppableId}-order-mode`}
            checked={!useGlobalOrder}
            onChange={() => onUseGlobalOrderChange(false)}
            className="accent-primary"
          />
          Tilpasset rækkefølge for denne widget
        </label>
      </div>

      {!useGlobalOrder && (
        <ItemReorderList
          items={items}
          droppableId={droppableId}
          onReorder={onItemOrderChange}
          renderItemLabel={renderItemLabel}
        />
      )}

      {onUpdateGlobalOrder && (
        <div className="pt-1">
          <Button
            type="button"
            variant="outline"
            size="sm"
            disabled={isUpdatingGlobal || items.length === 0}
            onClick={onUpdateGlobalOrder}
          >
            {isUpdatingGlobal ? "Opdaterer..." : "Opdater global rækkefølge"}
          </Button>
          <p className="text-xs text-muted-foreground mt-1">
            Gemmer den viste rækkefølge som standard på tværs af dashboards.
          </p>
        </div>
      )}
    </div>
  );
};

export default UserDataOrderSection;
